(function () {
  'use strict';

  angular.module('app').component('bookingItemPriceTable', bookingItemPriceTable());

  function bookingItemPriceTable() {
    return {
      bindings: {
        bookingItem: '<',
        currency: '<',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-price-table/booking-item-price-table.component.html',
    };
  }
})();
